import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Gallery from '../views/Gallery.vue'
import Category from '../views/Category.vue'
import Wagyu from '../views/Wagyu.vue'
import Shopping from '../views/Shopping.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  }, 
  {
    path: '/Gallery',
    name: 'Gallery',
    component: Gallery
  },
  {
    path: '/Category',
    name: 'Category',
    component: Category
  },
  {
    path: '/Category/Wagyu',
    name: 'Wagyu',
    component: Wagyu
  },
  {
    path: '/Shopping',
    name: 'Shopping',
    component: Shopping
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "about" */ '@/views/Login.vue'),
    meta: {
      title: '登录界面'
    }
  },
  {
    path: '/Categories',
    name: 'Categories',
    component: () => import('@/views/Categories.vue'),
    meta: {
      title: '产品分类'
    }
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

//页面切换时滚动到顶部
router.afterEach(()=>{
  window.scrollTo(0,0);
})

export default router
